import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { APIService } from '../../api.service';

@Component({
  selector: 'app-copy-from-product',
  templateUrl: './copy-from-product.component.html',
  styleUrls: ['./copy-from-product.component.scss']
})
export class CopyFromProductComponent implements OnInit {


  @Input() mdlRef: any;
  @Input() typeID: any;
  @Input() ri: number = 0; // Remove this item
  modalReference: any;

  MTbl: any = [];
  jarvisData: any = [];
  Items: any = [];
  search: string = '';
  productDetials = {
    bom: [],
    stages: []
  }

  constructor(private apiService: APIService) { }


  ngOnInit(): void {

    var tblM = this.apiService.getCookie("M");
    if(tblM) {
      this.MTbl = JSON.parse(tblM);
    }

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }  

    this.getData();

  }

  getData() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let data = [{
      StatusID: 1,
      StoreID: 0
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'get',
      moduleID: 5,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successRespItem.bind(this), this.failureRespItem.bind(this));
  }

  //successResp - success  get handler
  successRespItem(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let data = reponseData;

          let tempItems = data.Table1;
          this.Items = tempItems.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));

          if(this.ri > 0) {
            this.Items = this.Items.filter((z: any) => z.ItemID != this.ri);
          }

          this.Items = this.Items.filter((c: any) => c.IsMade == true && c.IsActive == 1);

          this.Items.forEach((element: any) => {
            element.isSelected = false;
          });

        }
      }
    }
  }

  //failureResp - failure handler
  failureRespItem(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  selectItem(obj: any) {
    this.Items.forEach((element: any) => {
      element.isSelected = false;
    });

    obj.isSelected = true;
  }

  closeModal() {
    this.mdlRef.close();
  }

  getProductDetails(id: number) {
    let data = [{
      productID: id
    }]

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.MTbl[0].ERPAgencyID,
        actionType: 'get',
        moduleID: 4,
        data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureRespItem.bind(this)); 
  }

  successResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if(reponseData.Table[0].ErrCode == 1){
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
            // this.router.navigateByUrl('/Stock');
        }
        else{
          let productData = reponseData.Table[0];
          

          this.productDetials.bom = JSON.parse(productData.BOM);            
          this.productDetials.stages = JSON.parse(productData.StageFlow);
          
          if(this.typeID == 1) {
            this.mdlRef.close(this.productDetials.stages);
          } else {
            this.mdlRef.close(this.productDetials.bom);
          }
          
        }
      }
    }
  }

  select() {
    let tmpPrdtID = this.Items.filter((a: any) => a.isSelected == true);
    let prdtID = tmpPrdtID[0].ItemID;
    this.getProductDetails(prdtID);
  }

}
